import { Suspense, useContext, useMemo } from 'react';
import { RouterProvider } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';

import CustomSnackbar from './components/CustomSnackbar';
import Loader from './components/Loader';
import Toast from './components/Toast';
import BrandThemeSync from './components/BrandThemeSync/BrandThemeSync';
import router from './route';
import usePreconnectToUrl from './hooks/usePreconnectToUrl';
import { SnackbarContext } from './globalContext/snackbar/snackbarProvider';
import { ThemeContext } from './globalContext/theme/themeProvider';
import { getActiveBrandConfig } from './theme/brands';
import { resolveAppTheme } from './theme/createBrandTheme';

function App() {
  const [themeState] = useContext(ThemeContext);
  const [snackbarInfo] = useContext(SnackbarContext);
  const brand = themeState?.brand ?? getActiveBrandConfig();
  const brandTheme = useMemo(() => resolveAppTheme(brand), [brand]);
  usePreconnectToUrl({
    url: process.env.REACT_APP_API_URL || '',
    id: 'preconnect-to-server',
  });

  return (
    <div
      className="app"
      style={{
        height: '100dvh',
        overflow: 'hidden',
        display: 'flex',
      }}
    >
      <ThemeProvider theme={brandTheme}>
        <BrandThemeSync />
        <Toast />
        <Suspense fallback={<Loader />}>
          <RouterProvider router={router}></RouterProvider>
        </Suspense>
        {snackbarInfo?.isVisible && (
          <CustomSnackbar
            {...{
              btnText: snackbarInfo?.btnText,
              duration: snackbarInfo?.duration,
              horizontal: snackbarInfo?.horizontalPos,
              message: snackbarInfo.message,
              muiIcon: snackbarInfo.muiIcon,
              onToastBtnClick: snackbarInfo?.onToastBtnClick,
              onToastClose: snackbarInfo.onToastClose,
              open: snackbarInfo.isVisible,
              showProgressiveLoader: snackbarInfo?.showProgressiveLoader,
              type: snackbarInfo?.type,
              vertical: snackbarInfo?.verticalPos,
            }}
          />
        )}
      </ThemeProvider>
    </div>
  );
}

export default App;
